import React, { useRef, useState, useEffect, useContext } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { MyDomain } from "../../App";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));
const textFieldStyles = {
  "& .MuiInput-underline:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.5,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:hover:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.8,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#6366f1",
    borderBottomWidth: "1px",
  },
  "& .MuiInputBase-root": {
    fontSize: "14px",
  },
};

// Custom theme to override MenuItem and Select styles
const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#e5e5e5", // Change selected option background color to gray
            "&:hover": {
              backgroundColor: "#e5e5e5", // Keep the same color on hover
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingLeft: 0, // Remove left padding
          textAlign: "left", // Align text to the left
        },
      },
    },
  },
});
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function AdminAdSectionUpdate({
  OneAdSection,
  open,
  setOpen,
  onUpdate,
}) {
  const { User, Token } = useAppContext();

  //   console.log(OneAdSection);
  //   console.log(open);
  const [AdSectionOBJ, setAdSectionOBJ] = useState(OneAdSection);

  useEffect(() => {
    setAdSectionOBJ(OneAdSection);
  }, [open]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setAdSectionOBJ((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setAdSectionOBJ((prevState) => ({
        ...prevState,
        dateStart: formattedDate,
      }));
    }
  };
  const handleDateChange2 = (date) => {
    if (date) {
      const formattedDate = date.format("DD-MM-YYYY");
      setAdSectionOBJ((prevState) => ({
        ...prevState,
        dateEnd: formattedDate,
      }));
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleUpdateAdTopSectionOBJ = async () => {
    const data = AdSectionOBJ;
    console.log(data);
    try {
      const response = await axios.put(
        `${MyDomain}AdSection/UpdateAdSection`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      onUpdate(AdSectionOBJ);
      setOpen(false);
    } catch (error) {
      console.log("Login error:", error.response?.data || error.message);
      //alert("Invalid credentials. Please try again.");
    }
  };
  const ModalCreateNewProduct = () => {
    return (
      <div>
        <React.Fragment>
          {/* <Button variant="outlined" onClick={handleClickOpen}>
                Open dialog
              </Button> */}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              UPDATE AD SECTION
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>

            <div
              style={{
                width: "100%",
                display: "flex",
                //flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  //height: "calc(90vh - 55px)",
                  //minHeight: "calc(60vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", width: "100%", marginBottom: 20 }}
                >
                  <a style={{ fontWeight: "bold" }}>ID: {OneAdSection.id}</a>
                </div>
                <TextField
                  id="standard-basic"
                  label="Code cat"
                  variant="standard"
                  name="codeCat"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={AdSectionOBJ.codeCat}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="Image"
                  variant="standard"
                  name="image"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={AdSectionOBJ.image}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <div style={{ width: "100%", paddingBottom: 25 }}>
                  {/* Ensures the container is 100% width */}
                  <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                    Date start
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        AdSectionOBJ.dateStart
                          ? dayjs(AdSectionOBJ.dateStart, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) => handleDateChange(date, "dateStart")}
                      slotProps={{
                        textField: {
                          variant: "standard", // Removes outer border and keeps only the underline
                          InputProps: {
                            disableUnderline: false, // Ensure underline is shown
                          },
                          sx: {
                            width: "100%", // Enforces full width on the text field
                            "& .MuiInputBase-root:before": {
                              borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                            },
                            "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                              {
                                borderBottom: "1px solid black", // Underline color on hover
                              },
                            "& .MuiInputBase-root:after": {
                              borderBottom: "2px solid #1976d2 ", // Underline color when focused
                            },
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            width: "100%", // Ensures TextField spans full width
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "red", // Default border color
                              },
                              "&:hover fieldset": {
                                borderColor: "red", // Hover border color
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "red", // Focus border color
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
                <div style={{ width: "100%", paddingBottom: 25 }}>
                  {/* Ensures the container is 100% width */}
                  <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                    Date end
                  </p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        AdSectionOBJ.dateEnd
                          ? dayjs(AdSectionOBJ.dateEnd, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) => handleDateChange2(date, "dateEnd")}
                      slotProps={{
                        textField: {
                          variant: "standard", // Removes outer border and keeps only the underline
                          InputProps: {
                            disableUnderline: false, // Ensure underline is shown
                          },
                          sx: {
                            width: "100%", // Enforces full width on the text field
                            "& .MuiInputBase-root:before": {
                              borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                            },
                            "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                              {
                                borderBottom: "1px solid black", // Underline color on hover
                              },
                            "& .MuiInputBase-root:after": {
                              borderBottom: "2px solid #1976d2 ", // Underline color when focused
                            },
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            width: "100%", // Ensures TextField spans full width
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "red", // Default border color
                              },
                              "&:hover fieldset": {
                                borderColor: "red", // Hover border color
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "red", // Focus border color
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
                <TextField
                  id="standard-basic"
                  label="Link To Take"
                  variant="standard"
                  name="linkToTake"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={AdSectionOBJ.linkToTake}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="Categoty"
                  variant="standard"
                  name="category"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={AdSectionOBJ.category}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="News code cat"
                  variant="standard"
                  name="newsCodeCat"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={AdSectionOBJ.newsCodeCat}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                <button
                  style={{
                    //marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                  }}
                  onClick={() => {
                    //handleSignup();
                    //when do the create use this for dates!!
                    // if (DateOfBirth !== null) {
                    //   formattedDate = ProductOBJ.dateStart.format("DD-MM-YYYY");
                    // }
                    handleUpdateAdTopSectionOBJ();
                  }}
                >
                  <a style={{ fontSize: 14 }}>UPDATE</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  };
  return <div>{ModalCreateNewProduct()}</div>;
}
